const groupCountriesByPrefix = countries => {
  const countriesByPrefix = new Map();
  countries.forEach(country => {
    countriesByPrefix.set(country.phone, [...(countriesByPrefix.get(country.phone) ?? []), country]);
  });
  return countriesByPrefix;
};

export { groupCountriesByPrefix };
//# sourceMappingURL=groupCountriesByPrefix.mjs.map
